import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-67bfea4e")
const _hoisted_1 = { class: "message-list-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = {
  key: 0,
  class: "content"
}
const _hoisted_6 = { class: "time" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_list, {
      "finished-text": "我已经到底了~~~",
      finished: _ctx.dataTotal === _ctx.messageList.length,
      onLoad: _ctx.onLoad,
      offset: 10
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({ 'message-item': true, read: item.isRead }),
            key: item.id,
            onClick: ($event: any) => (_ctx.onShowDetail(item))
          }, [
            _createVNode(_component_van_image, {
              class: "left",
              fit: "cover",
              src: 
            item.headImgId
              ? item.headImgId + '?imageView2/1/w/200/h/200/rotate/0'
              : 'https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/%E7%BB%84%20989%402x.png'
          
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1),
              (+item.type === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.content), 1))
                : (_openBlock(), _createBlock(_component_van_image, {
                    key: 1,
                    class: "zan",
                    fit: "cover",
                    src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/lvaixin.png"
                  })),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.initCreateFn(item.createTime)), 1)
            ])
          ], 10, _hoisted_2))
        }), 128))
      ]),
      _: 1
    }, 8, ["finished", "onLoad"])
  ]))
}